import { AuthorizationScope } from '@api/graphql/types';

export const videoRoutePermissions = {
  uploadVideoAttrbutes: [AuthorizationScope.MutationUploadVideoAttributesFile],
};
